var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_35-Add-contact",
    "data-name": "35-Add-contact",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.98,
    height: 14.98,
    viewBox: "0 0 14.98 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39772",
    "data-name": "Path 39772",
    d: "M10.745,9.49A3.745,3.745,0,1,0,7,5.745,3.745,3.745,0,0,0,10.745,9.49Zm0-6.42A2.675,2.675,0,1,1,8.07,5.745,2.675,2.675,0,0,1,10.745,3.07Z",
    transform: "translate(-4.325 -2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39773",
    "data-name": "Path 39773",
    d: "M12.165,23.35H3.07v-.535A3.745,3.745,0,0,1,6.815,19.07h3.21a3.708,3.708,0,0,1,1.873.5.535.535,0,0,0,.535-.92A4.74,4.74,0,0,0,10.025,18H6.815A4.815,4.815,0,0,0,2,22.815v1.07a.535.535,0,0,0,.535.535h9.63a.535.535,0,1,0,0-1.07Z",
    transform: "translate(-2 -9.44)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39774",
    "data-name": "Path 39774",
    d: "M24.815,22.14H23.21V20.535a.535.535,0,0,0-1.07,0V22.14H20.535a.535.535,0,0,0,0,1.07H22.14v1.605a.535.535,0,0,0,1.07,0V23.21h1.605a.535.535,0,0,0,0-1.07Z",
    transform: "translate(-10.37 -10.37)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusIcon);
export default __webpack_public_path__ + "static/media/userPlus_icon.e27d1e7b0c9af2e57d0af77319986ee0.svg";
export { ForwardRef as ReactComponent };